import React from "react";
import Head from "next/head";

import FeaturesMain from "@/components/features/features-main";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const Features = () => {
  return (
    <>
      <Head>
        <title>{seoData.FEATURES.title}</title>
        <SeoMetaData data={seoData.FEATURES} />
      </Head>{" "}
      <FeaturesMain />
    </>
  );
};

export default Features;
